<template>
  <div
    ref="dropdown"
    class="dropdown"
    :class="{'is--open': open}"
  >
    <div
      v-if="title"
      class="dropdown-title"
    >
      {{ title }}
    </div>
    <div class="dropdown-input">
      <div
        v-click-outside="close"
        class="input">
        <div
          class="input-field"
          @click="toggle"
        >
          <span v-if="items[selectedItem]">{{ items[selectedItem].title }}</span>
          <i class="ri-arrow-drop-down-line" />
        </div>
        <div
          v-show="open"
          ref="inputList"
          class="input-list"
          :class="{'is--top': topMode}"
          :style="{maxHeight: height + 'px'}"
        >
          <ul>
            <li v-for="elem in items" :key="elem.id" @click="selectItem(elem.id)">{{ elem.title }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
  
export default {
  directives: {
    ClickOutside
  },
  props: ['title', 'items', 'selected'],
  data() {
    return {
      open: false,
      height: 0,
      selectedItem: this.items.findIndex(item => item.id === this.selected),
      topMode: false
    }
  },
  methods: {
    toggle() {
      this.topMode = false;
      const modalBody = this.findClosestElem(this.$refs.inputList, 'modal__body');

      if(modalBody) {

        const modalOffsetTop = this.findClosestElem(this.$refs.inputList, 'vm--modal').getBoundingClientRect().top;
        const dropdownOffsetTop = this.$refs.dropdown.getBoundingClientRect().top;
        const offsetTopDiff = dropdownOffsetTop - modalOffsetTop;

        let height = modalBody.offsetHeight - offsetTopDiff - 20;

        if (height < 50) {
          const modalOffsetBottom = this.findClosestElem(this.$refs.inputList, 'vm--modal').getBoundingClientRect().bottom;
          const dropdownOffsetBottom = this.$refs.dropdown.getBoundingClientRect().bottom;
          const offsetBottomDiff = dropdownOffsetBottom - modalOffsetBottom;

          height = modalBody.offsetHeight - offsetBottomDiff - 20;
          this.topMode = true;
        }

        this.height = height;
      }

      this.open = !this.open;
    },
    findClosestElem(el, className) {
      while (el.parentNode) {
        el = el.parentNode;
        if (el.classList && el.classList.length && el.classList.contains(className))
          return el;
      }
      return null;
    },
    close() {
      this.open = false;
    },
    selectItem(id) {
      this.selectedItem = this.items.findIndex(item => item.id === id);
      this.$emit('onSelected', this.items[this.selectedItem])
      this.close();
    }
  }
}
</script>

<style lang="scss" scoped>
  .dropdown {
    &-title {
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      line-height: 130%;
      font-feature-settings: 'zero' on;
      color: var(--label-primary);
      letter-spacing: .5px;
      margin-bottom: 16px;
    }
    &-input {
      position: relative;
    }
    &.is--open {
      .input {
        &-field {
          i {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .input {
    &-field {
      display: flex;
      align-items: center;
      font-weight: 300;
      font-size: 16px;
      line-height: 150%;
      font-feature-settings: 'ss02' on;
      padding: 0px 32px 0px 8px;
      height: 32px;
      border: 1px solid var(--grey-03);
      cursor: pointer;
      position: relative;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
      }
      i {
        margin-left: auto;
        color: var(--accent-blue);
        font-size: 24px;
        position: absolute;
        top: 4px;
        right: 4px;
      }
    }
    &-list {
      position: relative;
      top: 100%;
      left: 0;
      width: 100%;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.16);
      background: var(--light-01);
      overflow: auto;
      z-index: 1;
      &.is--top {
        bottom: 100%;
        top: auto;
      }
      ul {
        list-style: none;
        li {
          font-size: 16px;
          font-weight: 300;
          line-height: 150%;
          font-feature-settings: 'ss02' on;
          cursor: pointer;
          padding: 4px 8px;
          border: 1px solid transparent;
          &:hover {
            border-color: var(--accent-blue);
          }
        }
      }
    }
  }
</style>
